import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import SearchIcon from '@mui/icons-material/Search';
import CenterFocusStrongOutlinedIcon from '@mui/icons-material/CenterFocusStrongOutlined';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';

export const KC_ICON_MAP = {
  psychology: PsychologyOutlinedIcon,
  editNote: EditNoteOutlinedIcon,
  trendingUp: TrendingUpOutlinedIcon,
  gavel: GavelOutlinedIcon,
  accountTree: AccountTreeOutlinedIcon,
  assignment: AssignmentOutlinedIcon,
  localHospital: LocalHospitalOutlinedIcon,
  savings: SavingsOutlinedIcon,
  description: DescriptionOutlinedIcon,
  policy: PolicyOutlinedIcon,
  swapHoriz: SwapHorizOutlinedIcon,
  hub: HubOutlinedIcon,
  dns: DnsOutlinedIcon,
  analytics: AnalyticsOutlinedIcon,
  speed: SpeedOutlinedIcon,
  work: WorkOutlineOutlinedIcon,
  groups: GroupsOutlinedIcon,
  insights: InsightsOutlinedIcon,
  shield: ShieldOutlinedIcon,
  document: ArticleOutlinedIcon,
  gear: SettingsSuggestOutlinedIcon,
  search: SearchIcon,
  target: CenterFocusStrongOutlinedIcon,
  docScan: DocumentScannerOutlinedIcon,
  sparkle: AutoAwesomeOutlinedIcon,
  agent: SupportAgentOutlinedIcon,
  menuBook: MenuBookOutlinedIcon,
};

export function KcIcon({ name, className = '', fontSize = 'medium', sx }) {
  const Icon = KC_ICON_MAP[name] || DescriptionOutlinedIcon;
  return <Icon className={className} fontSize={fontSize} sx={sx} />;
}
